export const ActionCellStyles = () => ({
  width: '1%',
  whiteSpace: 'nowrap',
  backgroundColor: '#fff',
  position: 'sticky',
  right: 0,

  'th&': {
    position: 'sticky',
    alignItems: 'baseline',
  },

  'td&': {
    textAlign: 'right',
    padding: '10px',
    paddingRight: '20px', /* For MacOS scrollbar-related bug (scrollbar overflows with action column) */
    'tr:hover &': {
      backgroundImage: 'linear-gradient(to right, transparent , rgb(245 245 245) 30%)',
    },

    '& > *:not(:last-child)': {
      paddingRight: 10,
    },
  },

  'tbody tr:hover &': {
    backgroundColor: 'rgb(245 245 245)',
  },
});
